module.exports = __webpack_public_path__ + "static/media/roundaboutCCW45.de99b405.svg";